type MuiFilledInputType = { [k: string]: any };

const MuiFilledInput: MuiFilledInputType = {
  root: {},
};

export default MuiFilledInput;
